import { useParams } from "react-router-dom";

export const useIdSearchParams = () => {
  const params = useParams();

  return params.id ? parseInt(params.id, 10) : null;
};
